/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import createAsyncMutation from '../../utils/generators'

// Initial state
const state = {
  status: null,
  error: null,
  vehicles: [],
  vehicle: {
    vehicle: {}
  }
}

// Getters
const getters = {
  vehiclesLoading: state => state.status === 'loading',
  vehiclesStatus: state => state.status,
  vehiclesError: state => state.error,
  vehicles: state => state.vehicles,
  vehicle: state => state.vehicle,
  vehicleDetails: state => state.vehicle.details
}
// Mutations
const mutations = {
  GET_VEHICLES_PENDING(state) {
    state.status = 'loading'
  },
  GET_VEHICLES_SUCCESS(state, vehicles) {
    state.status = 'success'
    state.vehicles = vehicles.data
    state.error = null
  },
  GET_VEHICLES_FAILURE(state, error) {
    state.status = 'error'
    state.error = error || 'We failed to fetch the vehicles'
  },
  GET_VEHICLE_PENDING(state) {
    state.status = 'loading'
  },
  GET_VEHICLE_SUCCESS(state, vehicle) {
    state.status = 'success'
    state.vehicle = vehicle.data
    state.error = null
  },
  GET_VEHICLE_FAILURE(state, error) {
    state.status = 'error'
    state.error = error || 'We failed to fetch this vehicle'
  },
  PUT_VEHICLE_PENDING(state) {
    state.status = 'loading'
  },
  PUT_VEHICLE_SUCCESS(state) {
    state.status = 'success'
  },
  PUT_VEHICLE_FAILURE(state, error) {
    state.status = 'error'
    if (error.status === 403) {
      state.error = error.data.detail
    } else {
      const keys = Object.keys(error.data)
      state.error = `${keys[0]}: ${error.data[keys[0]][0]}` // Show 1st error for 1st key
    }
  }
}

// Actions
const actions = {
  getVehicles: ({ dispatch, rootState }) => {
    const url = `${rootState.api.host}/${rootState.api.endpoints.vehicles}/`
    const mutationTypes = createAsyncMutation('GET_VEHICLES')
    dispatch('fetch', { url, mutationTypes })
  },
  getVehicle: ({ dispatch, rootState }, id) => {
    const url = `${rootState.api.host}/${rootState.api.endpoints.vehicles}/`
    const options = { params: { vehicle: id } }
    const mutationTypes = createAsyncMutation('GET_VEHICLE')
    return dispatch('fetch', { url, mutationTypes, options }).then(vehicle => vehicle)
  },
  saveVehicle: ({ dispatch, rootState }, data) => {
    const url = `${rootState.api.host}/${rootState.api.endpoints.vehicle}/${data.id}/`
    const mutationTypes = createAsyncMutation('PUT_VEHICLE')
    return dispatch('put', { url, mutationTypes, data }).then(vehicle => vehicle)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vehicles.js